import { PositionScenarios } from "../../types";

export const groupsLeagueScenarios: PositionScenarios = {
  "1": {
    "1": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      { "1": 0, "2": 0, "3": 0, "4": 1, "5": 0, "6": 0, "7": 1, "8": 0 },
      { "1": 0, "2": 0, "3": 1, "4": 0, "5": 0, "6": 0, "7": 1, "8": 0 },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 1 },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 1, "9": 1, "10": 0 },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 1, "6": 0, "9": 1, "10": 0 },
      { "1": 0, "2": 0, "3": 0, "4": 1, "5": 0, "6": 0, "7": 0 },
      { "1": 0, "2": 0, "3": 1, "4": 0, "5": 0, "6": 0, "7": 0 },
      { "1": 0, "2": 1, "3": 0, "4": 0, "5": 0, "6": 0, "7": 1 },
      { "1": 1, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0, "7": 1 },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 1, "9": 0 },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 1, "6": 0, "9": 0 },
      { "1": 0, "2": 0, "3": 0, "4": 0, "5": 0, "6": 0 },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      { "1": 0, "2": 1, "3": 0, "4": 1, "7": 0, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 0, "3": 0, "4": 1, "7": 0, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "7": 1, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 0, "5": 1, "6": 1, "7": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 0, "5": 0, "7": 0, "8": 1, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "5": 1, "6": 0, "7": 0, "8": 0, "9": 1, "10": 0 },
      { "1": 0, "2": 1, "3": 1, "7": 0, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 0, "3": 1, "7": 0, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "3": 0, "7": 1, "8": 0, "9": 0, "10": 0 },
      { "1": 1, "2": 1, "5": 1, "6": 0, "7": 0, "8": 0, "9": 0 },
      { "1": 1, "2": 1, "5": 0, "7": 0, "8": 0, "9": 1, "10": 0 },
      { "1": 1, "2": 1, "5": 0, "7": 0, "8": 0, "9": 0 },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      { "3": 1, "4": 1, "5": 1, "6": 1, "7": 1, "8": 1, "9": 0, "11": 0 },
    ],
    "4": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
    ],
  },
  "2": {
    "1": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
      },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
    ],
    "4": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
    ],
  },
  "3": {
    "1": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
    ],
    "4": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
    ],
  },
  "4": {
    "1": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      { "1": 0, "2": 1, "3": 1, "4": 1, "5": 1, "6": 1, "7": 1, "8": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 1, "5": 1, "6": 1, "7": 1, "8": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 1, "6": 1, "7": 0, "8": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 1, "6": 1, "7": 0, "8": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 0, "6": 1, "9": 0, "10": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 1, "6": 0, "9": 0, "10": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 1, "5": 1, "6": 1, "7": 0 },
      { "1": 1, "2": 0, "3": 1, "4": 1, "5": 1, "6": 1, "7": 0 },
      { "1": 1, "2": 1, "3": 0, "4": 1, "5": 1, "6": 1, "7": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 0, "5": 1, "6": 1, "7": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 0, "6": 1, "9": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 1, "6": 0, "9": 1 },
      { "1": 1, "2": 1, "3": 1, "4": 1, "5": 1, "6": 1 },
    ],
    "2": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      { "1": 0, "2": 0, "3": 0, "4": 1, "7": 0, "8": 1, "9": 1, "10": 1 },
      { "1": 0, "2": 1, "3": 1, "4": 0, "7": 1, "8": 1, "9": 1, "10": 1 },
      { "1": 1, "2": 0, "3": 1, "4": 0, "7": 1, "8": 1, "9": 1, "10": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 0, "6": 0, "7": 1, "9": 1, "10": 1 },
      { "1": 0, "2": 0, "3": 1, "5": 1, "7": 1, "8": 0, "9": 1, "10": 1 },
      { "1": 0, "2": 0, "5": 0, "6": 1, "7": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "2": 0, "3": 1, "7": 0, "8": 1, "9": 1, "10": 1 },
      { "1": 0, "2": 1, "3": 0, "7": 1, "8": 1, "9": 1, "10": 1 },
      { "1": 1, "2": 0, "3": 0, "7": 1, "8": 1, "9": 1, "10": 1 },
      { "1": 0, "2": 0, "5": 0, "6": 1, "7": 1, "8": 1, "9": 1 },
      { "1": 0, "2": 0, "5": 1, "7": 1, "8": 1, "9": 0, "10": 1 },
      { "1": 0, "2": 0, "5": 1, "7": 1, "8": 1, "9": 1 },
    ],
    "3": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "11": 1,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "11": 1,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 1,
      },
      { "3": 0, "4": 0, "5": 0, "6": 0, "7": 0, "8": 0, "9": 1, "11": 1 },
    ],
    "4": [
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.25 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.3333333333333333 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 1,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 1,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 1,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 1,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 0,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 1,
        "2": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 1,
        "10": 1,
        "11": 0,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 1,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 1,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 1,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 0,
        "5": 1,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 1,
        "11": 0,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 1,
        "12": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 0,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
        meta: { share: 0.5 },
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 0,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 1,
        "11": 0,
        "12": 0,
      },
      {
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 1,
        "12": 1,
        meta: { share: 0.5 },
      },
      {
        "1": 0,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "2": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "2": 0,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 1,
        "9": 0,
        "10": 0,
      },
      {
        "1": 0,
        "3": 1,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 0,
        "4": 1,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "11": 0,
      },
      {
        "1": 1,
        "3": 1,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "8": 0,
        "9": 0,
        "11": 0,
      },
      {
        "1": 0,
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 1,
        "9": 0,
        "10": 0,
        "11": 0,
      },
      {
        "3": 0,
        "4": 0,
        "5": 0,
        "6": 0,
        "7": 0,
        "8": 0,
        "9": 0,
        "11": 0,
        "12": 0,
      },
    ],
  },
  "5": { "1": [], "2": [], "3": [], "4": [] },
  "6": { "1": [], "2": [], "3": [], "4": [] },
};
